/**
* Web Service handler to retrieve and represent a list of locations to the
* authenticated location administrator account
*
* @class AuthInfoWS
*/
var AuthInfoWS = function (parent) {
	var self = this; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this Web Service handler on the Abstract class of a Web
	// Service handler. This establishes core functionality required of
	// these such handlers, which can be overwritten by methods below.
	AbstractWS.apply( this, arguments );

	self.name				= 'AuthInfoWS';				// Convenience name for debugging
	self.roles				= ko.observableArray( [] );	// Collection of Roles for the
														// authenticated user


	/**
	* Defines the string to request API services
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/employee/authInfo';
	});


	/**
	 * Determines if the user has a specific role
	 *
	 * @method hasRole
	 * @param {String} sRole
	 * @returns {Boolean}
	 */
	self.hasRole = function (role) {
		return self.roles().indexOf(role) > -1;
	};


	/**
	* This method iterates over the data returned from the service and
	* converts the individual nodes into LocationModels and then assigns
	* them to this object's locations collection.
	*
	* @method processData
	* @param {XMLString} xmlData XML data returned from the service
	* @return {AuthInfoWS} Returns the object as chainable, for best practice
	*/
	self.processData = function ( xmlData ) {
		var aRoles = [],				// Array of roles parsed from the XML
			aTemp = [];					// Temporary collection of LocationModels

		// Call the superclass method to perform any core actions
		AbstractWS.prototype.processData.call(self, xmlData);

		aRoles = $( xmlData ).find('roles').toArray();

		aTemp = aRoles.reduce( function ( arr, role ) {
			arr.push( role.innerHTML || role.textContent );
			return arr;
		}, [] );

		self.roles( aTemp );

		// Return self (AuthInfoWS) to be chainable, for best practice
		return self;
	}

	return self;
};

AuthInfoWS.prototype = AbstractWS.prototype;
AuthInfoWS.prototype.constructor = AuthInfoWS;
